import { computed } from 'vue'
import store from '@/store'
import Cookie from 'cookiejs'


let initialized = false

/**
 * Initialize the consents from the cookie
 * if user eventually visited the site before
 */
function initFromCookie() {
  try {
    let accepted = Cookie.get('accepted-cookies') || {};

    if (typeof accepted === 'string') {
      accepted = Object.fromEntries(JSON.parse(accepted).map((key) => [key, true]))
      store.commit('consent/setConsents', accepted)

      if (Object.keys(accepted).length) {
        touch();
      }
    }


  } catch (e) {
    console.error(e);
  }
}
const isPristine = computed(() => store.getters['loopCookieBanner/isPristine']);

function init() {
  if (initialized) {
    return
  }
  initialized = true


  if (isPristine.value) {
    initFromCookie();
  }


  store.watch(
    state => state.consent.given,
    (given) => {
      const acceptedKeys = Object.keys(given).filter(key => given[key])
      Cookie.set('accepted-cookies', JSON.stringify(acceptedKeys))
    }
  )
}


function touch() {
  store.commit('loopCookieBanner/touch')
}


export function useLoopCookieBanner() {

  init();

  const processUrl = (url) => {
    let locale = window.location.pathname.match(/^\/([a-z]{2})\//)?.[1] ?? '';

    url = url.replace('{locale}', locale)

    return url
  }

  return {
    /**
     * Convert the consent names to the ones used in the app
     * and update the consents in the store
     *
     * @param {{[key:string]: boolean}} consents
     */
    updateConsents(consents) {
      store.commit('consent/setConsents', consents)
    },
    isEnabled: computed(() => process.env.VUE_APP_LOOP_COOKIE_BANNER_ENABLE === 'true'),
    touch,
    isPristine,
    showSettings() {
      store.commit('loopCookieBanner/showSettings')
    },
    hideSettings() {
      store.commit('loopCookieBanner/hideSettings')
    },
    /**
     * @return {Promise<string>}
     */
    loadSettingsHtml() {
      let url = process.env.VUE_APP_LOOP_COOKIE_BANNER_SETTINGS_API_URL;

      if (!url) {
        throw new Error('Settings URL is not defined')
      }

      url = processUrl(url);

      return fetch(url, {
        method: 'GET'
      })
        .then(response => response.json())
        .then(data => {
          return data.html
        })
    },
    /**
     * @return {Promise<import('@/src/types').CookieBannerConfig>}
     */
    loadCookieBannerConfig() {
      let url = process.env.VUE_APP_LOOP_COOKIE_BANNER_CONFIG_API_URL;

      if (!url) {
        throw new Error('Settings URL is not defined')
      }
      url = processUrl(url);

      return fetch(url, {
        method: 'GET'
      })
        .then(response => response.json())
        .then(data => {
          return data.data
        })
    }
  }
}
